export default "__VITE_ASSET__7zNciRIV__"